import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import _isEqual from 'lodash/isEqual';
import { all } from 'rsvp';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { union } from 'macro-decorators';

const ACTIONS = {
  CREATE: 'create',
  MANAGE: 'manage',
  EDIT: 'edit',
};

export default class SettingsEmailsTemplatesController extends Controller {
  queryParams = ['action'];

  @tracked action = null;

  @service flashMessages;

  @union('model.mailerTemplateVersionsByCompany', 'model.mailerTemplateVersionsByLocation') mailerTemplateVersions;

  get isCreateModalOpen() {
    return this.action === ACTIONS.CREATE;
  }

  set isCreateModalOpen(value) {
    this.action = value ? ACTIONS.CREATE : null;
  }

  get isManageModalOpen() {
    return this.action === ACTIONS.MANAGE;
  }

  set isManageModalOpen(value) {
    this.action = value ? ACTIONS.MANAGE : null;
  }

  get isEditing() {
    return this.action === ACTIONS.EDIT;
  }

  set isEditing(value) {
    this.action = value ? ACTIONS.EDIT : null;
  }

  @action
  async saveNewTemplateVersion(mailerTemplateVersion) {
    const { flashMessages } = this;
    const { mailerTemplateVersionsByLocation, mailerTemplate } = this.model;
    try {
      await mailerTemplateVersion.save();
      await mailerTemplateVersionsByLocation.update();
      flashMessages.showAndHideFlash('success', 'Template created!');
      await this.transitionToRoute(
        'visitors.settings.emails.templates.versions',
        mailerTemplate.id,
        mailerTemplateVersion.id,
        {
          queryParams: {
            action: 'edit',
          },
        }
      );
    } catch (e) {
      flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
      mailerTemplateVersion.rollbackAttributes();
      throw e;
    }
  }

  @action
  async saveRecipients(mailerTemplateVersions) {
    const { flashMessages } = this;
    try {
      await all(mailerTemplateVersions.map((mailerTemplateVersion) => mailerTemplateVersion.save()));
      flashMessages.showAndHideFlash('success', 'Saved!');
    } catch (e) {
      flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
      throw e;
    }
  }
}
